module.exports = __webpack_public_path__ + "img/92.593b5030.jpg";